// @flow
import ContrastColorUpdater from "../../helper/ContrastColorUpdater";
import useThemeStylesheet from "../../hooks/useThemeStylesheet";

const AlfaRomeoTheme = props => {
	useThemeStylesheet(() => import("./alfaRomeo.lazy.scss"));
	return <>
		<ContrastColorUpdater/>
		{props.children}
	</>;
};

export default AlfaRomeoTheme;
